<template>
    <div v-if="newForm.isShow"
         class="voice-change">
        <div class="title-box">
            <p class="name">背景音管理</p>
            <p class="close"
               @click="close"
            >x</p>
        </div>
        <div v-if="newForm.url" class="content">
            <p class="name">{{newForm.name}}</p>
            <p class="line"></p>
            <div class="row">
                <p class="btn">
                    <span
                            v-if="!newForm.play"
                            class="iconfont icon-bofang opt"
                            @click="handleClickPlay"
                    ></span>
                    <span
                            v-else
                            class="iconfont icon-zanting_heise opt"
                            @click="pause"
                    ></span>
                    <span
                            class="iconfont icon-shanchu delete"
                            @click="handleDelete"
                    ></span>
                </p>
                <div class="play-progress">
                    <!--<span class="iconfont icon-yinliang"></span>-->
                    <el-slider
                        class="slider" v-model="value"
                        :show-tooltip="false"
                        @change="onSlider"
                    ></el-slider>
                    <!--<span class="label">{{showValue}}</span>-->
                    <div class="time">
                        <span>{{showTime}}</span>
                    </div>
                </div>
            </div>
            <p class="line"></p>
            <div class="voice-box">
                <span class="name">音量调节</span>
                <el-slider
                    class="slider"
                    v-model="newForm.volume"
                    :show-tooltip="false"
                    @change="toCocos"
                ></el-slider>
                <span class="num">{{newForm.volume}}</span>
            </div>
            <p class="line"></p>
            <div class="checked-box">
                <el-checkbox
                        v-if="newForm.isLoop!==undefined"
                        v-model="newForm.isLoop"
                        @change="toCocos"
                >循环</el-checkbox>
                <el-checkbox
                        v-if="newForm.clickPlay!==undefined"
                        v-model="newForm.clickPlay"
                        @change="toCocos"
                >点击播放</el-checkbox>
                <el-checkbox
                        v-if="newForm.autoPlay!==undefined"
                        v-model="newForm.autoPlay"
                        @change="toCocos"
                >自动播放</el-checkbox>
            </div>
        </div>
        <div v-else class="content">
            <span class="warn">当前暂无页面背景音，可点击右侧音频添加</span>
        </div>
    </div>
</template>

<script>
    import {
        AudioPlay,
        AudioPause,
        AudioWatchTime,
        AudioAllTime,
        AudioCurTime
    } from "../../utils/audio";

    export default {
        name: "voice-change",
        props: {
            isShow: Boolean,
            form: Object
        },
        computed: {
            showValue(){
                let state = 0
                try {
                    if(this.newForm.allTime>0) {
                        state = (this.newForm.curTime / this.newForm.allTime * 100).toFixed(0)
                    }
                }catch (e) {
                    console.log('showValue失败==>', e)
                }
                return state
            },
            showTime(){
                let state = '0.00/0.00'
                try {
                    if(this.newForm.allTime>0) {
                        state = `${this.newForm.displayTime}/${this.newForm.allTimeShow}`
                    }
                }catch (e) {
                    console.log('showTime失败==>', e)
                }
                return state
            },
            cocosConfig(){
                const {
                    name,
                    isShow,
                    isBackground,
                    isLoop,
                    url,
                    volume
                } = this.newForm
                return {
                    name,
                    isShow,
                    isBackground,
                    isLoop,
                    url,
                    volume
                }
            }
        },
        watch:{
            isShow(vl){
                this.newForm.isShow = vl
            },
            form :{
                handler (vl) {
                    this.newForm = vl
                },
                deep: true,
                immediate: true
            },
            newForm :{
                handler (vl) {
                    this.value = parseInt(this.showValue)
                    this.$emit('update:isShow', vl.isShow)
                    this.$emit('update:form', vl)
                },
                deep: true,
                immediate: true
            }
        },
        data(){
            return {
                newForm: this.form,
                // {
                //     name: '咩咩咩咪sssnnbcnbn',
                //     isShow: this.isShow,
                //     isBackground: false,
                //     isLoop: false,
                //     displayTime: 0,
                //     curTime: 0,
                //     allTime: 0,
                //     playTime: 0,
                //     play: false,
                //     url: '',
                // },
                value: 0,
                voice: 50
            }
        },
        methods: {
            toCocos(){
                // 向cocos发通知
                let obj = {
                    ...this.cocosConfig
                }
                let newObj = {type: 'EditBgm',value: obj}
                if(this.newForm.index>-1){
                    newObj.index = this.newForm.index
                }
                this.$toCocosMessage(newObj)
            },
            // 删除当前背景音
            handleDelete(){
                const url = this.newForm.url
                if(url) {
                    this.$toWebMessage({type: 'DelResource',value:{type:'audio', url}})
                }
                this.newForm.url = ''
                this.toCocos()
            },
            setNewForm({data}){
              console.log('setNewForm==>', data)
              let oldNewForm = this.$_.cloneDeepWith(this.newForm)
              this.newForm = {
                  ...oldNewForm,
                  ...data
              }
            },
            play(isOld){
                this.newForm.play = true
                AudioPlay({url:this.newForm.url, isOld: isOld, volume: this.newForm.volume})
            },
            pause () {
                this.newForm.play = false
                AudioPause()
            },
            close(){
                this.newForm.isShow = false
            },
            onSlider(value) {
                console.log('滑动大小==>', value)
                const target = this.newForm
                if(target.allTime<=0){
                    this.value = 0
                    return false
                }
                AudioCurTime(Math.round(value / 100 * target.allTime))
                target.play = true
                this.play(target.playTime>0)
            },
            handleClickPlay () {
                console.log('开始播放==>')
                const target = this.newForm
                // 播放 1.获取当前播放总时间 2.及检测当前播放位置
                target.play = false
                this.play(target.playTime>0)
                this.handleSelectAudio()
            },
            handleClickPause () {
                // 暂停 1.暂停所有
                this.data.map(v => {
                    v.play = false
                })
                AudioPause()
            },
            handleSelectAudio () {
                AudioWatchTime(this.setCurTime)
                AudioAllTime(this.setAllTime)
            },
            setCurTime (item) {
                const target = this.newForm
                target.displayTime = item.displayTime
                target.curTime = item.seconds
                target.playTime = target.curTime / target.allTime * 100
            },
            setAllTime (item) {
                const target = this.newForm
                target.allTimeShow = item.displayTime
                target.allTime = item.seconds
            },
        }
    }
</script>

<style lang="scss" scoped>
.voice-change{
    position: absolute;
    right: 24px;
    top: 24px;
    z-index: 998;
    width:323px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.15);
    border-radius:4px;

    .title-box{
        height:41px;
        background:rgba(228,231,237,1);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .name{
            font-size:14px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(48,49,51,1);
            line-height:20px;
            margin-left: 16px;
        }
        .close{
            padding: 12px;
            cursor: pointer;
        }
    }
    .content{
        padding: 16px;

        .name{
            font-size:14px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:20px;
        }
        .line{
            width: 100%;
            border-bottom: 1px solid #EBEEF5;
            margin: 8px 0px;
        }
        .row{
            height: 30px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .play-progress{
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 300px;

                .slider{
                    width: 130px;
                    margin-left: 14px;
                }
                .label{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:20px;
                    margin-left: 12px;
                }
            }
            .btn{
                .opt{
                    font-size: 20px;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .delete{
                    font-size: 20px;
                    cursor: pointer;
                }
            }
        }
        .time{
            font-size:14px;
            font-weight:400;
            color:rgba(192,196,204,1);
            height: 30px;
            line-height:30px;
            margin-left: 14px;
        }
        .voice-box{
            display: flex;
            flex-direction: row;
            align-items: center;

            .name{
                font-size: 14px;
                font-weight: 400;
                color: #606266;
                line-height: 20px;
            }
            .slider{
                width: 161px;
                margin-left: 12px;
                margin-right: 14px;
            }
            .num{
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                line-height: 20px;
            }
        }
        .checked-box{
            font-size:14px;
            font-weight:400;
            color:rgba(96,98,102,1);
            line-height:20px;
            margin-top: 8px;
        }

        .warn{
            font-size: 14px;
            font-weight: 400;
            color: #303133;
            line-height: 20px;
            display: flex;
            height: 100px;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
